export class Property {
  placeId: number;
  hotelId: number;
  isActive: boolean;
  id: string;
  name: string;
  address: string | null;
  city: string | null;
  state: string | null;
  createdAt: Date;
  updatedAt: Date;
  _count?: {
    rooms: number;
  };

  constructor(dto: any) {
    this.id = dto.id;
    this.name = dto.name;
    this.address = dto.address;
    this.city = dto.city;
    this.state = dto.state;
    this.createdAt = new Date(dto.created_at);
    this.updatedAt = new Date(dto.updated_at);
    this.placeId = dto.place_id;
    this.hotelId = dto.hotel_id;
    this.isActive = dto.is_active;
  }
}

export class PropertyWithRoomCount extends Property {
  roomCount: number;

  constructor(dto: any) {
    super(dto);
    this.roomCount = dto.room_count;
  }
}
